import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageDetails: {
    pagenum: 0,
    pagesize: 0,
    recordstartindex: 0,
    recordendindex: 0,
  },
  isLoading: false,
  tab: { key: null, value: "" },
  sortby: {},
  selectedRows: [],
  filters: {},
  clearFilters: false,
  clearSelectedRows: false,
};

const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    onPageChange: (state, action) => {
      state.pageDetails = action.payload;
    },

    handleLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    onTabChange: (state, action) => {
      state.tab = action.payload;
    },

    onChangeSortby: (state, action) => {
      state.sortby = action.payload;
    },

    onSelectionChange: (state, action) => {
      state.selectedRows = action.payload;
    },

    onChangeFilters: (state, action) => {
      state.filters = action.payload;
    },

    clearAllTableFilters: (state, action) => {
      return {
        ...state,
        filters: {},
        clearFilters: action.payload,
      };
    },

    clearSelectedRowsData: (state, action) => {
      state.clearSelectedRows = action.payload;
    },
  },
});

export default tableSlice.reducer;
export const {
  onPageChange,
  handleLoading,
  onTabChange,
  onChangeSortby,
  onSelectionChange,
  onChangeFilters,
  clearAllTableFilters,
  clearSelectedRowsData,
} = tableSlice.actions;
